import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logOut } from 'modules/user';
import { browserHistory } from 'react-router';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getSupportedLocales, getLocaleDisplayName } from '../intl/helpers';

class Navigation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      citefixDismissed: typeof localStorage !== 'undefined' && localStorage.getItem('citefix_banner_dismissed') === 'true'
    };
  }

  dismissCitefix(e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('citefix_banner_dismissed', 'true');
    }
    this.setState({ citefixDismissed: true });
  }

  render() {
    let { user, isPreview, intl, dispatch } = this.props;

    if (!user.authenticated || isPreview) return (<div></div>);
    return (
      <nav className="navbar-fixed-left">
        {!this.state.citefixDismissed &&
          <a
            className="citefix-banner"
            href="https://apps.shopify.com/citefix"
            target="_blank"
            rel="noopener noreferrer"
          >
            <style dangerouslySetInnerHTML={{__html: `
              .citefix-banner { position: relative; display: block; text-decoration: none; background: linear-gradient(135deg, #4F46E5, #7c3aed); color: #fff; padding: 12px 14px; border-radius: 10px; margin-bottom: 12px; box-shadow: 0 2px 8px rgba(79,70,229,0.3); }
              .citefix-banner:hover { color: #fff; box-shadow: 0 4px 12px rgba(79,70,229,0.45); }
              .citefix-banner .citefix-badge { display: inline-block; font-size: 9px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; background: rgba(255,255,255,0.2); padding: 2px 6px; border-radius: 4px; margin-bottom: 6px; }
              .citefix-banner .citefix-title { font-size: 13px; font-weight: 700; margin: 0; }
              .citefix-banner .citefix-desc { font-size: 11px; opacity: 0.9; margin: 2px 0 0; line-height: 1.35; }
              .citefix-banner .citefix-cta { font-size: 11px; font-weight: 600; margin-top: 6px; display: inline-flex; align-items: center; gap: 4px; }
              .citefix-banner .citefix-dismiss { position: absolute; top: 6px; right: 6px; background: none; border: none; color: rgba(255,255,255,0.75); font-size: 13px; line-height: 1; cursor: pointer; padding: 4px; }
              .citefix-banner .citefix-dismiss:hover { color: #fff; }
              @media (max-width: 992px) { .citefix-banner .citefix-title, .citefix-banner .citefix-desc, .citefix-banner .citefix-cta { display: none; } .citefix-banner .citefix-badge { margin-bottom: 0; } }
            `}} />
            <button
              type="button"
              className="citefix-dismiss"
              title={intl.formatMessage({ id: 'nav.dismiss', defaultMessage: 'Dismiss' })}
              onClick={this.dismissCitefix.bind(this)}
            >
              <i className="fa fa-times"></i>
            </button>
            <span className="citefix-badge"><i className="fa fa-bolt"></i> New app</span>
            <p className="citefix-title">CiteFix</p>
            <p className="citefix-desc"><FormattedMessage id="nav.citefixDesc" defaultMessage="See the answer AI gives buyers, the pages it cited, and approve every fix yourself." /></p>
            <span className="citefix-cta"><FormattedMessage id="nav.citefixCta" defaultMessage="Check it out" /> <i className="fa fa-arrow-right"></i></span>
          </a>
        }
        <div className="nav-section">
          <div className="nav-section-label"><FormattedMessage id="nav.main" /></div>
          <a title={intl.formatMessage({ id: 'nav.ordersAndInvoices' })} id="orders-menu" className="navbar-item" href={'/' + intl.locale + '/dashboard'}>
            <i className="fa fa-list navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.ordersAndInvoices" /></span>
          </a>
          <a title={intl.formatMessage({ id: 'nav.drafts' })} id="drafts-menu" className="navbar-item" href={'/' + intl.locale + '/drafts'} style={{ paddingLeft: '30px', fontSize: '13px' }}>
            <i className="fa fa-file-text-o navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.drafts" /></span>
          </a>
          <a title={intl.formatMessage({ id: 'nav.automation' })} id="autopilot-menu" className="navbar-item" href={'/' + intl.locale + '/autopilot'}>
            <i className="fa fa-magic navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.automation" /></span>
          </a>
        </div>

        {user && user.profile && user.profile.subscription !== "suspended" &&
          <div className="nav-section">
            <div className="nav-section-label"><FormattedMessage id="nav.workspace" /></div>
            <a title={intl.formatMessage({ id: 'nav.templates' })} id="templates-menu" className="navbar-item" href={'/' + intl.locale + '/templates'}>
              <i className="fa fa-paint-brush navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.templates" /></span>
            </a>
            <a title={intl.formatMessage({ id: 'nav.delivery' })} id="delivery-menu" className="navbar-item" href={'/' + intl.locale + '/delivery'}>
              <i className="fa fa-paper-plane navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.delivery" /></span>
            </a>
            <a title={intl.formatMessage({ id: 'nav.settings' })} id="settings-menu" className="navbar-item" href={'/' + intl.locale + '/bookkeeping'}>
              <i className="fa fa-cog navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.settings" /></span>
            </a>
            <a title={intl.formatMessage({ id: 'nav.shippingLabels' })} id="labels" className="navbar-item" href={'/' + intl.locale + '/labels'}>
              <i className="fa fa-tag navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.shippingLabels" /></span>
            </a>
            <a title={intl.formatMessage({ id: 'nav.subscriptions' })} id="billing-menu" className="navbar-item" href={'/' + intl.locale + '/billing'}>
              <i className="fa fa-credit-card navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.subscriptions" /></span>
            </a>
          </div>
        }

        <div className="nav-section">
          <div className="nav-section-label"><FormattedMessage id="nav.support" /></div>
          <a id="dev-menu" title={intl.formatMessage({ id: 'nav.developer' })} className="navbar-item" href={'/' + intl.locale + '/developer'}>
            <i className="fa fa-code navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.developer" /></span>
          </a>
          <a id="review-menu" title={intl.formatMessage({ id: 'nav.writeReview' })} href="https://apps.shopify.com/invoice-browse?#modal-show=ReviewListingModal" className="navbar-item" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-star navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.writeReview" /></span>
          </a>
          <a title={intl.formatMessage({ id: 'nav.supportTicket' })} href="mailto:tickets@invoice-browse.p.tawk.email" className="navbar-item" target="_blank" rel="noopener noreferrer">
            <i className="fa fa-life-ring navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.supportTicket" /></span>
          </a>
          <a id="welcome-tour-menu" className="navbar-item" onClick={() => {
            localStorage.setItem(user.shopify.shopName + 'joyride-index', 0);
            localStorage.setItem(user.shopify.shopName + 'run-joyride', null);
            location.href = '/' + intl.locale + '/dashboard';
          }} title={intl.formatMessage({ id: 'nav.welcomeTour' })}>
            <i className="fa fa-compass navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.welcomeTour" /></span>
          </a>
        </div>

        <div className="nav-section nav-section-bottom">
          <div className="navbar-item" style={{ padding: '8px 15px' }}>
            <i className="fa fa-globe navbar-item-icon"></i>
            <select
              value={intl.locale}
              onChange={(e) => {
                const newLocale = e.target.value;
                if (typeof localStorage !== 'undefined') {
                  localStorage.setItem('invoicebrowse_locale', newLocale);
                }
                const path = window.location.pathname.replace(/^\/[a-z]{2}(-[A-Z]{2})?(\/|$)/, '/');
                window.location.href = '/' + newLocale + (path === '/' ? '/dashboard' : path);
              }}
              style={{ width: '100%', padding: '3px 6px', borderRadius: '4px', border: '1px solid #555', fontSize: '12px', background: '#2c3e50', color: '#ecf0f1', cursor: 'pointer' }}
            >
              {getSupportedLocales().map(code => (
                <option key={code} value={code}>{getLocaleDisplayName(code)}</option>
              ))}
            </select>
          </div>
          <a title={intl.formatMessage({ id: 'nav.logout' })} className="navbar-item" onClick={() => { dispatch(logOut(intl.locale)) }}>
            <i className="fa fa-sign-out navbar-item-icon"></i>
            <span className="navbar-item-text"><FormattedMessage id="nav.logout" /></span>
          </a>
          {user.isAdmin && (
            <a title={intl.formatMessage({ id: 'nav.administratorConsole' })} className="navbar-item" onClick={() => { browserHistory.push('/' + intl.locale + '/administrator') }}>
              <i className="fa fa-lock navbar-item-icon"></i>
              <span className="navbar-item-text"><FormattedMessage id="nav.administratorConsole" /></span>
            </a>
          )}
        </div>
      </nav>
    );
  }
}

Navigation.propTypes = {
  user: PropTypes.object,
  logOut: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user,
    isPreview: browserHistory && browserHistory.getCurrentLocation().pathname.indexOf('/preview') !== -1,
    isEditor: browserHistory && browserHistory.getCurrentLocation().pathname.indexOf('/editor') !== -1,
    logOut: logOut
  };
}

export default injectIntl(connect(mapStateToProps)(Navigation));



// WEBPACK FOOTER //
// app/containers/Navigation.jsx